import React from 'react';
import PropTypes from 'prop-types';
import MuiFormHelperText from '@mui/material/FormHelperText';
import { styled } from '@mui/material/styles';

const StyledFormHelperText = styled(MuiFormHelperText)(({ theme }) => {
  return {
    marginTop: theme.spacing(0.5),
    fontSize: '0.75rem',
  };
});

const FormHelperText = (props) => {
  return <StyledFormHelperText {...props} />;
};

FormHelperText.propTypes = {
  children: PropTypes.node,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default FormHelperText;
